/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
export const CheckIcon = ({ size = 12 }) => (
    <Icon size={size} width={3.5}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
)

/* PLUS ICON */
export const PlusIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M12 5v14M5 12h14" />
    </Icon>
)

/* EDIT ICON */
export const EditIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M11 4H7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-4" />
        <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
    </Icon>
)

/* TRASH ICON */
export const TrashIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" />
        <path d="M10 11v5M14 11v5" />
    </Icon>
)

/* SEARCH ICON */
export const SearchIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="10.8" cy="10.8" r="6.8" />
        <path d="M20.5 20.5 15.7 15.7" />
    </Icon>
)

/* LOCK ICON — NOT A SUPERADMIN, NOTHING CHANGES */
export const LockIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="4" y="11" width="16" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </Icon>
)

/* COIN ICON — THE CURRENCY AVATAR */
export const CoinIcon = ({ size = 20 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M9.5 9.2a2.6 2.6 0 0 1 2.6-1.7c1.6 0 2.7.9 2.7 2s-.9 1.6-2.6 2c-1.9.4-2.9 1-2.9 2.2 0 1.1 1.1 2 2.7 2a2.7 2.7 0 0 0 2.7-1.7" />
        <path d="M12 6.3v1.2M12 16.5v1.2" />
    </Icon>
)

/* CHIP ICON — THE CHIP COEFFICIENT */
export const ChipIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="3.4" />
        <path d="M12 3v3.3M12 17.7V21M21 12h-3.3M6.3 12H3M18.4 5.6l-2.3 2.3M7.9 16.1l-2.3 2.3M18.4 18.4l-2.3-2.3M7.9 7.9 5.6 5.6" />
    </Icon>
)

/* TABLE ICON — TABLES USING THIS CURRENCY */
export const TableIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="2.5" y="4.5" width="19" height="12" rx="4" />
        <path d="M8 20h8M12 16.5V20" />
    </Icon>
)
